import { DOCUMENT } from '@angular/common';
import { Component, OnInit, Inject, Input } from '@angular/core';
import { faHome, faThList, faCog, faAngleDown, faBook } from '@fortawesome/free-solid-svg-icons';
import * as _ from 'lodash-es';
import { Subscription } from 'rxjs';
import { MsalService } from 'msal';
import { commonService, PartnerdatamanagementService, ProxyService } from 'shared/services';
import { NgSessionStorage, NgLocalStorage } from 'core/utils/ng-storage.service';
import { AuthenticationService } from 'core/authentication.service';
import { PartnerDataServiceUrl } from 'core/utils/partnerdataserviceurl.constant';
import { ToastmessageService } from 'shared/services/toastmessage.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { ConfirmationDialogService } from 'shared/components/confirmation-dialog/confirmation-dialog.service';
import { appCommonConstant } from 'core/utils/common.constant';

@Component({
  selector: 'app-layout-header',
  templateUrl: './layout-header.component.html',
  styleUrls: ['./layout-header.component.scss']
})
export class LayoutHeaderComponent implements OnInit {

  @Input() environment: any;

  faHome = faHome;
  faThList = faThList;
  faBook = faBook;
  faCog = faCog;
  faAngleDown = faAngleDown;

  loggedIn = false;
  userName: String = '';
  userTemplate: any = 'userInfo.html';
  universities: any = [];
  popoverTrigger = false;
  university = {};
  PartnerGUID = '';
  selectedSolution: any;

  userPerms: any = [];
  partnername: any;
  statusList = [];
  solutionList: { name: string; alias: string; idName: string; imageSrc: string; id: string; perm: any; defaultPage: string; UserGroup: string }[];
  currenturl: string;
  showPartner: boolean;
  currentPartner: any;
  dataDictionaryUrl = '';

  constructor(
    @Inject(DOCUMENT) private readonly document: any,
    private msalAuthService: MsalService,
    private authService: AuthenticationService,
    private _data: commonService,
    private _router: Router,
    private _proxyService: ProxyService,
    private ngSessionStorage: NgSessionStorage,
    private ngLocalStorage: NgLocalStorage,
    private _toastmsgService: ToastmessageService,
    private route: ActivatedRoute,
    private partnerData: PartnerdatamanagementService,
    private confirmationDialogService: ConfirmationDialogService,
  ) {
    this.route.queryParams.subscribe(params => {
      this.PartnerGUID = params['PartnerGUID'];
      if (this.PartnerGUID)
        this.ngSessionStorage.setItem('PartnerGUID', this.PartnerGUID);
    });
    // this._router.events.pipe(filter(value => value instanceof NavigationEnd)).subscribe((event: any) => {
    //   this.ngSessionStorage.setItem('PartnerGUID', this.PartnerGUID);
    // });
  }
  selectedPartner: Object;
  
  assignPartner() {

    this.universities.map(partner => {
      if (partner.PartnerGUID == this.ngSessionStorage.getItem('PartnerGUID')) {
        this.selectedPartner = partner;
        this.partnerData.selectedPartner.next(partner);
        this.ngSessionStorage.setItem('selectedPartner', JSON.stringify(partner));
      };
    });
  }

  getUniversityInfo(): void {
    this._proxyService.getData(PartnerDataServiceUrl.GetAll('Partnerdetail', 'PartnerData', this.environment.servicePartnerDataURL), false)
      .subscribe(
        (response: any) => {
          this.universities = _.orderBy(response, ["UniversityFullName"], ["asc"]);
          this.authService.setPartnerdetail(this.universities);
          this._toastmsgService.successDialog('');
          if (this._router.url != '/dashboard') {
            this.assignPartner();
          }
        },
        (error: any) => {
          this._toastmsgService.errorDialog(error.message);
        }
      );
  }

  changePartner(data, mode) {
    mode = 'Partner';
    this.checkEnabled(data, mode);
    setTimeout(() => {
      if(appCommonConstant.is_dirty_check){
        this.selectedPartner = this.currentPartner.UniversityFullName
      }
    }, 100);
    
    if(!appCommonConstant.is_dirty_check){
      this.selectedPartner = data;
      this.ngSessionStorage.setItem('selectedPartner', JSON.stringify(data));
      this.ngSessionStorage.setItem('PartnerGUID', data.PartnerGUID);
      this.partnerData.selectedPartner.next(data);
        let isChildren = this.ngSessionStorage.getItem('isChildren');
        if (!isChildren || (window.location.href == (window.location.origin + this.selectedSolution.defaultPage))) {
          if(window.location.href != (window.location.origin + window.location.pathname) || window.location.href.includes(this.selectedSolution.defaultPage)) {
            window.location.href = window.location.origin + this.selectedSolution.defaultPage;
          } else {
            window.location.reload();
          }
        } else {
            window.location.href = window.location.origin + this.selectedSolution.defaultPage;
        }
    }
  }
  subscription: Subscription;  

  ngOnInit(): void {
    this.dataDictionaryUrl = this.environment?.dataDictionaryBaseUrl || '';
    this.solutionList = [];
    this.showPartner = true;
    var userName;
    setTimeout(() => {
      let userDetail: any = this.ngLocalStorage.getItem('userDetail');
      this.userName = JSON.parse(userDetail).UserName;
      this.userPerms = this.authService.getCurrentUser(this.msalAuthService);
      this.solutionList = this.authService.GetSolutionList(this.msalAuthService);
      setTimeout(() => {
        this.setSelectedSolution(true);
      }, 500);
      if (this.userName)
        this.getUniversityInfo();
    }, 500);
    
    let selectedPartner = this.ngSessionStorage.getItem('selectedPartner');
    this.currentPartner = JSON.parse(selectedPartner)
    if (selectedPartner && (selectedPartner != undefined && selectedPartner != 'undefined')) {
      this.selectedPartner = JSON.parse(selectedPartner);
    }
    this.showPartner = true;
    this.currenturl = this._router.url.split('?')[0];
    this._router.events.subscribe((event: any) => {
      if (event.url) {
        this.currenturl = event.url.split('?')[0];        
        if (this.currenturl.includes('dashboard')) {
          this.showPartner = false;
        } else if (event.route && event.route.path === 'dashboard') {
          this.showPartner = false;
        } else if(event.url && (event.url === '/' && event.urlAfterRedirects && event.urlAfterRedirects.includes('dashboard'))) {
          this.showPartner = false;
        }
        this.setSelectedSolution(false);
      }
    });
    if (this.currenturl.includes('dashboard')) {
      this.showPartner = false;
    }

    this.subscription = this.partnerData.selectedPartner.subscribe({ next: (val) => this.selectedPartner = val });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  setSelectedSolution(setdata) {
    setTimeout(()=>{
      let selectedSolution = this.ngSessionStorage.getItem('selectedSolution');
      if (selectedSolution && (selectedSolution != undefined && selectedSolution != 'undefined')) {
        if(this.solutionList) {
          this.solutionList.forEach(slt => {
            if(slt.idName === selectedSolution.idName){
              this.ngSessionStorage.setItem('selectedSolution' , slt);
              this.selectedSolution = selectedSolution;
            }
          });   
        }   
      }
    },400)
   
  }

  redirectToDashboard(mode) {
    mode = 'Dashboard';
    this.checkEnabled(null, mode);
    if(!appCommonConstant.is_dirty_check){
      this.ngSessionStorage.setItem("dashboardRedirectPrevUrl", window.location.href);
      window.location.replace(`${this.document.location.origin}` + `/dashboard`);
    }
  }
  redirectToWorkflowDashboard(mode) {
    mode = 'WorkFlowDashboard'
    this.checkEnabled(null, mode);
    if(!appCommonConstant.is_dirty_check){
      this.ngSessionStorage.setItem("dashboardRedirectPrevUrl", window.location.href);
      window.location.replace(`${this.document.location.origin}` + `/dashboard/WorkflowDashboard`);
    }
  }

  redirectToDigitizeAdministration() {

  }

  checkEnabled(data, mode){
    let result = appCommonConstant.is_dirty_check;

    if (mode == 'Partner'){
      if(result == true){
        this.confirmationDialogService.confirm('Confirm', 'It looks like you have been editing something. Do you want to redirect to another page?', 'YES', 'Cancel')
          .then((confirmed) => {
            if (confirmed) {
              appCommonConstant.is_dirty_check = false;
              this.changePartner(data, mode);
            }
          })
          .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
      }
    } else if(mode == 'Solution'){
      if(result == true){
        this.confirmationDialogService.confirm('Confirm', 'It looks like you have been editing something. Do you want to redirect to another page?', 'YES', 'Cancel')
          .then((confirmed) => {
            if (confirmed) {
              appCommonConstant.is_dirty_check = false;
              this.changeSolution(data, mode);
            }
          })
          .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
      }
    } else if(mode =='Dashboard'){
      if(result == true){
        this.confirmationDialogService.confirm('Confirm', 'It looks like you have been editing something. Do you want to redirect to another page?', 'YES', 'Cancel')
          .then((confirmed) => {
            if (confirmed) {
              appCommonConstant.is_dirty_check = false;
              this.redirectToDashboard(mode);
            }
          })
          .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
      }
    } else if(mode == 'WorkFlowDashboard'){
      if(result == true){
        this.confirmationDialogService.confirm('Confirm', 'It looks like you have been editing something. Do you want to redirect to another page?', 'YES', 'Cancel')
          .then((confirmed) => {
            if (confirmed) {
              appCommonConstant.is_dirty_check = false;
              this.redirectToWorkflowDashboard(mode)
            }
          })
          .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
      }
    }
  }


  changeSolution(solution, mode) {
    mode = 'Solution';
    this.checkEnabled(solution, mode);
    if(!appCommonConstant.is_dirty_check){
    this.selectedSolution = solution;
    this.ngSessionStorage.setItem('selectedSolution', this.selectedSolution);
    if (this.selectedSolution.id == "4" || this.selectedSolution.id == "5") {
      this.popoverTrigger = false;
    } else {
      this.popoverTrigger = true;
    }
    var id = solution.id;
    if (id == "1") {
      this.ngSessionStorage.setItem('UserGroup', 'APEdge');
      //  $window.name = JSON.stringify(SharedDataService.getSharedDataFromSession());
      //  $window.location.href = $window.location.origin + '/PDM/#/Partners/Information';
    }
    else if (id == "2") {
      this.ngSessionStorage.setItem('UserGroup', 'APDigitize');
      //  $window.name = JSON.stringify(SharedDataService.getSharedDataFromSession());
      //  $window.location.href = $window.location.origin + '/APDigitize/#/Partners/StandardPages';
    }
    else if (id == "3") {
      this.ngSessionStorage.setItem('UserGroup', 'APEdge');
      //  $window.name = JSON.stringify(SharedDataService.getSharedDataFromSession());
      //  $window.location.href = $window.location.origin + '/#/Workflow';
    }
    else if (id == "4") {
      this.ngSessionStorage.setItem('UserGroup', 'APCarousel');
      //  $window.name = JSON.stringify(SharedDataService.getSharedDataFromSession());
      //  $window.location.href = $window.location.origin + '/APCarousel/#/program';
    }
    else if (id == "5") {
      this.ngSessionStorage.setItem('UserGroup', 'APIntegrationPortal');
      //  $window.name = JSON.stringify(SharedDataService.getSharedDataFromSession());
      //  $window.location.href = $window.location.origin + '/dataintake/#/partner/Information';
    }
    else if (id == "6") {
      this.ngSessionStorage.setItem('UserGroup', 'APTemplate');
      //  $window.name = JSON.stringify(SharedDataService.getSharedDataFromSession());
      //  $window.location.href = $window.location.origin + '/APTemplate/#/Templates/EmailTemplates';
    }
    window.location.href = `${this.document.location.origin}/${solution.defaultPage}`;
    // this._router.navigate([solution.defaultPage]);
    }
  }

  customSearchFn(term, items) {
    term = term.toLowerCase();
    let rtndt = false;
    if (items.UniversityFullName && items.InternalUniversityCode) {
      rtndt = items.UniversityFullName.toLowerCase().indexOf(term) > -1 || items.InternalUniversityCode.toLowerCase().indexOf(term) > -1;
    } else if (items.UniversityFullName && !items.InternalUniversityCode) {
      rtndt = items.UniversityFullName.toLowerCase().indexOf(term) > -1;
    } else if (!items.UniversityFullName && items.InternalUniversityCode) {
      rtndt = items.InternalUniversityCode.toLowerCase().indexOf(term) > -1;
    }
    return rtndt;
  }

  logout() {
    this.msalAuthService.logout();
  }
}
